<template>
    <div>
      <CCard class="p-2" style="border:none;">
        <CRow class="m-2">
            <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                <div :class="{'blue-background': activeButton === button.value, 'blue-text': activeButton !== button.value}" @click="setActiveButton(button.value)" class="p-2">
                    <img style="max-width:20px" class="mr-2" /> {{ button.label }}
                </div>
            </CCol>
            <CCol sm="6">
            <CButton
              size="md"
              class="mr-3 mt-3 mb-3 float-right btn-border-blue font-color-0B63F6"
              @click="OpenAdd()"
            >
            <img src="../assets/img/add-circle.png" style="max-width:20px" class="mr-1"/>
              Add Staff
            </CButton>
          </CCol>

        </CRow>
    </CCard>
    <CCard class="p-2 custom-border-radius-16px" style="border:none;">
                <div v-if="activeButton === 'ActiveStaff'">
                     <div>
                        <CCol sm="12" md="4" lg="3" style="float:left">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="d-flex font-color-171717">
                                        <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                            <option :value="10">10</option>
                                            <option :value="25">25</option>
                                            <option :value="50">50</option>
                                            <option :value="100">100</option>
                                        </select> <label class="m-2">entries </label>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" class="mb-2">
                                        <img :src="require('@/assets/img/printer.png')" alt="View" style="cursor: pointer;width:30px" class="ml-2" />
                                    </CCol>
                                    <CCol sm="10" class="mb-2">
                                        <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <br /><br /><br />
                        <CCol sm="12">
                            <table class="table table-responsive-sm" v-if="Array.isArray(filteredListStaffTableData) && filteredListStaffTableData.length > 0">
                                <thead class="custom-table">
                                    <th>No</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Employee No</th>
                                    <th>Designation</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in filteredListStaffTableData" :key="item.id" v-if="item.Active !== false">
                                        <td>
                                            <label class="custom-14px-500 font-color-98A2B3">{{ (currentPage - 1) * pageSize + index + 1 }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.FullName }}</label>
                                        </td>
                                        <td>
                                            <label 
                                                class="custom-12px-500"
                                                :class="item.Active === true ? 'status-joined' : item.Active === null ? 'status-pending' : 'status-deactive'">
                                                {{ item.Active === true ? 'Joined' : item.Active === null ? 'Pending' : 'Deactive' }}
                                            </label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.StaffNo }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.PositionName }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.PhoneNumber }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.Email }}</label>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <!-- <img :src="require('@/assets/img/edit 2.png')" alt="Print" style="cursor: pointer;width:30px" @click="editStatus(item.Id)"class="ml-2" /> -->
                                                <!-- <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openDetails(item.Id)" class="ml-2" /> -->
                                                <!-- <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" @click="DeactiveStaff(item.Id)" class="ml-2" /> -->
                                                <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openDetails(item.Id)" class="ml-2" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <div v-else class="no-data-message">
    
                                <div class="full-height-container">
                                    <div class="no-data-message">
                                        <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                        <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                        <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                    </div>
                                </div>
    
                            </div>
    
                        </CCol>
                        <div style="clear:both"></div>
                        <CRow>
                            <CCol sm="12" md="12" lg="12">
                                <button @click="loadFirstPage" :disabled="currentPage === 1" class="custom-btn-page" style="border-bottom-left-radius: 5px; border-top-left-radius: 5px;">First</button>
                                <button @click="loadPrevPage" :disabled="currentPage <= 1" class="custom-btn-page"> < Previous</button>
                                <span v-for="pageNumber in visiblePageNumbers" :key="pageNumber">
                                    <button @click="loadPage(pageNumber)" :class="{ active: pageNumber === currentPage }" class="custom-btn-page" style="width:25px">{{ pageNumber }}</button>
                                </span>
                                <button @click="loadNextPage" :disabled="!hasNextPage" class="custom-btn-page" style="border-bottom-right-radius: 5px; border-top-right-radius: 5px;">Next ></button>
                            </CCol>
                        </CRow>
    
    
    
    
                                        </div>
                </div>
                <div v-if="activeButton === 'ResignedStaff'">
                                        <div>
                        <CCol sm="12" md="4" lg="3" style="float:left">
                            <div>
                                <CRow>
                                    <CCol sm="12" class="d-flex font-color-171717">
                                        <label class="m-2">Show </label><select v-model="perPage" id="entries" class="form-control">
                                            <option :value="10">10</option>
                                            <option :value="25">25</option>
                                            <option :value="50">50</option>
                                            <option :value="100">100</option>
                                        </select> <label class="m-2">entries </label>
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <CCol sm="12" md="4" lg="3" style="float:right">
                            <div>
                                <CRow>
                                    <CCol sm="2" class="mb-2">
                                        <img :src="require('@/assets/img/printer.png')" alt="View" style="cursor: pointer;width:30px" class="ml-2" />
                                    </CCol>
                                    <CCol sm="10" class="mb-2">
                                        <CInput type="text" placeholder="Search...." v-model.lazy="SearchQuery" @change="applyFilter()" />
                                    </CCol>
                                </CRow>
    
    
                            </div>
                        </CCol>
                        <br /><br /><br />
                        <CCol sm="12">
                            <table class="table table-responsive-sm" v-if="Array.isArray(filteredListStaffTableData) && filteredListStaffTableData.length > 0">
                                <thead class="custom-table">
                                    <th>No</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Employee No</th>
                                    <th>Designation</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Action</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item,index) in filteredListStaffTableData" :key="item.id" v-if="item.Active === false">
                                        <td>
                                            <label class="custom-14px-500 font-color-98A2B3">{{ (currentPage - 1) * pageSize + index + 1 }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.FullName }}</label>
                                        </td>
                                        <td>
                                            <label 
                                                class="custom-12px-500"
                                                :class="item.Active === true ? 'status-joined' : item.Active === null ? 'status-pending' : 'status-deactive'">
                                                {{ item.Active === true ? 'Joined' : item.Active === null ? 'Pending' : 'Deactive' }}
                                            </label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.StaffNo }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.PositionName }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.PhoneNumber }}</label>
                                        </td>
                                        <td>
                                            <label class="custom-14px-500">{{ item.Email }}</label>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <!-- <img :src="require('@/assets/img/edit 2.png')" alt="Print" style="cursor: pointer;width:30px" @click="editStatus(item.Id)"class="ml-2" /> -->
                                                <!-- <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openDetails(item.Id)" class="ml-2" /> -->
                                                <!-- <img :src="require('@/assets/img/delete.png')" alt="View" style="cursor: pointer; width:30px" @click="DeactiveStaff(item.Id)" class="ml-2" /> -->
                                                <img :src="require('@/assets/img/view.png')" alt="View" style="cursor: pointer;width:30px" @click="openDetails(item.Id)" class="ml-2" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
    
                            <div v-else class="no-data-message">
    
                                <div class="full-height-container">
                                    <div class="no-data-message">
                                        <img src="../assets/img/NODATA.png" alt="No Data" style="max-width:100px;" />
                                        <p class="custom-16px-600 font-inter font-color-0B63F6 m-0">No Data Available</p>
                                        <p class="custom-14px-400 font-inter font-color-171717">Your search “Landing page design” did not <br /> match any projects. Please try again.</p>
                                    </div>
                                </div>
    
                            </div>
    
                        </CCol>
                        <div style="clear:both"></div>
                        <CRow>
                            <CCol sm="12" md="12" lg="12">
                                <button @click="loadFirstPage" :disabled="currentPage === 1" class="custom-btn-page" style="border-bottom-left-radius: 5px; border-top-left-radius: 5px;">First</button>
                                <button @click="loadPrevPage" :disabled="currentPage <= 1" class="custom-btn-page"> < Previous</button>
                                <span v-for="pageNumber in visiblePageNumbers" :key="pageNumber">
                                    <button @click="loadPage(pageNumber)" :class="{ active: pageNumber === currentPage }" class="custom-btn-page" style="width:25px">{{ pageNumber }}</button>
                                </span>
                                <button @click="loadNextPage" :disabled="!hasNextPage" class="custom-btn-page" style="border-bottom-right-radius: 5px; border-top-right-radius: 5px;">Next ></button>
                            </CCol>
                        </CRow>
    
    
    
    
                                        </div>
                </div>
    </CCard>

      <CCard>
        <div v-if="addUser" class="popup-all backdrop-all">
            <div class="popup-all2">
                <!-- Popup content -->
                <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopup" />
                <div class="text-left">
                    <CCol sm="12">
                    <form>
                    <CRow>
                        <CCol sm="12">
                            <strong class="text-left">Name</strong>
                            <CInput type="text" class="" v-model="name" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <strong class="text-left">NRIC/Passport</strong>
                            <CInput type="text" class="" v-model="nric" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <strong class="text-left">Address</strong>
                            <CInput type="text" class="" v-model="address" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <strong class="text-left">Email</strong>
                            <CInput type="text" class="" v-model="userEmail" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <strong class="text-left">Staff Number</strong>
                            <CInput type="text" class="" v-model="staffNo" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Status Employment</strong>
                            <v-select v-model="selectedEmployment" :options="employmentOptions" label="Name"></v-select>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Date Join Company</strong>
                            <CInput type="date" class="" v-model="dateJoinCompany" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <strong class="text-left">Country</strong>
                                <v-select v-model="selectedCountry" :options="countryOptions" label="CountryName" @input="onCountrySelect"></v-select>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Phone Number</strong>
                                    <strong class="phone-input">
                                    <CInput v-model="selectedCountryCode" :options="countryCodeOptions" :disabled="true" class="country-code-select"/>
                                    <CInput type="text" v-model="phone" placeholder="Enter your phone number" class="phone-number-input"/>
                                    </strong>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Position</strong>
                            <v-select v-model="selectedPosition" :options="positionOptions" label="Name"></v-select>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Department</strong>
                            <v-select v-model="selectedDepartment" :options="departmentOptions" label="Name"></v-select>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Bank Name</strong>
                            <v-select v-model="selectedBank" :options="bankOptions" label="Name"></v-select>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">Account Bank Number</strong>
                            <CInput type="text" class="" v-model="accBankNo" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <strong class="text-left">User Type</strong>
                            <v-select v-model="selectedRole" :options="roleOptions" label="Name"></v-select>
                        </CCol>
                    </CRow>
                    
                    </form>
                </CCol>
                </div>
                <div class="text-right mt-4">
                    <!-- <span class="btn-border-blue font-color-0B63F6 p-2 text-center pr-2 pl-2" @click="RegisterStaff()">Add Staff</span> -->
                    <CButton class="btn-border-blue font-color-0B63F6 p-2 text-center pr-2 pl-2"  @click="RegisterStaff">Add Staff</CButton>
                </div>
            </div>
        </div>
      </CCard>

      <div v-if="OpenDetailss" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
               
                <CRow>
                    <CCol sm="10"><h3 class="custom-24px-600 font-inter text-left">Details Staff</h3></CCol>
                    <CCol sm="2">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupDetail" />
                    </CCol>
                </CRow>

                
                <div class="text-left">
                    <CCol sm="12" class="p-0">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Date Join Company</label>
                            <CInput type="text" class="custom-border-form" :value="detailStaff.DateJoinCompany | moment('DD-MM-YYYY')"
                              disabled/>
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">NRIC/Passport</label>
                            <CInput type="text" class="custom-border-form" v-model="detailStaff.Nric"
                              disabled/>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Address</label>
                            <CTextarea class="" v-model="detailStaff.Address" rows="3" disabled />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Bank Name</label>
                            <CInput type="text" class="" v-model="detailStaff.BankName" disabled/>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Account Bank Number</label>
                            <CInput type="text" class="" v-model="detailStaff.AccBankNo" disabled/>
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Status Employment</label>
                            <CInput type="text" class="" v-model="detailStaff.StatusEmployment" disabled/>
                        </CCol>
                    </CRow>
                  
                   
                </CCol>
                </div>
                
            </div>
        </div>
        <div v-if="OpenEdit" class="popup-all backdrop-all">
            <div class="popup-all1">
                <!-- Popup content -->
                <div v-if="Error" class="ml-4 mr-4 mt-4">
                  <CAlert show color="danger">
                    <strong class="text-danger mr-2">Error !</strong> {{ Message }}
                  </CAlert>
                </div>
                <CRow>
                    <CCol sm="10"><h3 class="custom-24px-600 font-inter text-left">Update Staff Detail</h3></CCol>
                    <CCol sm="2">
                        <img src="../assets/img/close.png" style="max-width:50px;" @click="closePopupEdit" />
                    </CCol>
                </CRow>

                
                <div class="text-left">
                    <CCol sm="12" class="p-0">
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Name</label>
                            <CInput type="text" class="custom-border-form" v-model="detailStaff.FullName" />
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Staff Number</label>
                            <CInput type="text" class="custom-border-form" v-model="detailStaff.StaffNo" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Email</label>
                            <CInput type="text" class="custom-border-form" v-model="detailStaff.Email" />
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Nric/Passport</label>
                            <CInput type="text" class="custom-border-form" v-model="detailStaff.Nric" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Phone Number</label>
                            <CInput type="text" class="" v-model="detailStaff.PhoneNumber" />
                        </CCol>
                        <CCol sm="6">
                            <label class="font-inter custom-14px-500">Date Join Company</label>
                            <CInput type="date" class="" v-model="detailStaff.DateJoinCompany" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Address</label>
                            <CInput type="text" class="custom-border-form" v-model="detailStaff.Address" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Bank Name</label>
                            <v-select type="text" class="" v-model="detailStaff.BankName" :options="bankOptions" label="Name" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <label class="font-inter custom-14px-500">Account Bank Number</label>
                            <CInput type="text" class="" v-model="detailStaff.AccBankNo" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12">
                            <label class="font-inter custom-14px-500">Department Name</label>
                            <v-select type="text" class="" v-model="detailStaff.DepartmentName" :options="departmentOptions" label="Name" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <label class="font-inter custom-14px-500">Position Name</label>
                            <v-select type="text" class="" v-model="detailStaff.PositionName" :options="positionOptions" label="Name" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <label class="font-inter custom-14px-500">Employment</label>
                            <v-select type="text" class="" v-model="detailStaff.StatusEmployment" :options="employmentOptions" label="Name" />
                        </CCol>
                    </CRow>
                    <CRow>
                        <CCol sm="12" class="mt-3">
                            <label class="font-inter custom-14px-500">User Type</label>
                            <v-select type="text" class="" v-model="detailStaff.UserType" :options="roleOptions" label="Name" />
                        </CCol>
                    </CRow>
                </CCol>
                </div>
                <div class="text-right mt-4">
                    <CRow>
                        <CCol sm="6"> <CButton class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="closePopupEdit" block>Cancel</CButton></CCol>
                        <CCol sm="6">
                            <CButton class="p-2 text-center mr-2 bg-0B63F6 text-white border-half" @click="SubmitUpdate(detailStaff.Id)" block>Submit</CButton>
                        </CCol>
                        </CRow>
                </div>
            </div>
        </div>
        
    </div>
  </template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';

Vue.use(VuejsDialog);
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            columns: [
                'No',
                'Name',
                'Status',
                'EmployeeNo',
                'Designation',
                'PhoneNumber',
                'Email',
                
                
                'Action'
            ],
            options: {
                perPage: 5,
                pagination: true,
                filterable: false,
                searchable: true
            },
            addUser: false,
            selectedCountry: "",
            countryOptions: [],
            selectedCountryCode: "",
            countryCodeOptions: [],
            selectedDepartment: "",
            departmentOptions: [],
            selectedPosition: "",
            positionOptions: [],
            roleOptions: [],
            selectedRole: "",
            allStaff: [],
            Error: false,
            selectedBank: "",
            bankOptions: [],
            selectedEmployment: "",
            employmentOptions: [],

            OpenDetail: false,
            staff: [],
            detailStaff: {},
            OpenEdit: false,

            //For pagination
            perPage: "",
            currentPage: 1,
            pageSize: 5,
            totalPages: 10,
            filteredListStaffTableData: [],
            SearchQuery: "",
            hasNextPage: "",

            listStaffTableData: [],

            activeButton: 'ActiveStaff', // Default active button
            buttons: [
                { value: 'ActiveStaff', label: 'Active Staff'},
                { value: 'ResignedStaff', label: 'Resigned Staff'},
            ]
        }
    },
    async mounted() {
        await this.GetInfoUser();
        await this.GetUserType();
        await this.GetCountry();
        await this.GetDepartment();
        await this.GetPosition();
        await this.GetBank();
        await this.GetEmployment();
        await this.loadData();
        await this.GetListDetailStaff();
    },
    watch: {
        perPage(newValue) {
            this.pageSize = parseInt(newValue); // Ensure the value is an integer
            this.currentPage = 1; // Reset to the first page
            this.loadData(); // Reload data with new page size
        },
        SearchQuery: function(newVal, oldVal) {
            console.log('SearchQuery updated:', newVal);
            this.loadData();
        },
    },
    computed: {

    },
    created() {},
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },

        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        // AddStaff()
        // {
        //     this.$router.push("AddStaff");
        // },
        OpenAdd() {
            this.name = "";
            this.userEmail = "";
            this.staffNo = "";
            this.phone = "";
            this.selectedCountry = "";
            this.selectedCountryCode = "";
            this.selectedDepartment = "";
            this.selectedPosition = "";
            this.selectedBank = "";
            this.selectedEmployment = "";
            this.addUser = true;
        },
        closePopup() {
            this.addUser = false;
        },
        async GetCountry() {
            try {
                const response = await this.$API.get(this.$GetCountry);
                if (response.status === 200) {
                this.countryOptions = response.data;
                this.countryCodeOptions = response.data.map(country => ({
                    label: `+${country.CountryCallingCode}`,
                    value: country.CountryCallingCode,
                }));
                } else {
                console.error("Failed to fetch country information:", response);
                }
            } catch (error) {
                console.error("Error fetching country information:", error);
            }
        },
        onCountrySelect(selected) {
            this.selectedCountryCode = selected.CountryCallingCode; // Assuming your country data includes a CountryCallingCode field
        },
        async GetDepartment() {
                try {
                    const response = await this.$API.get(this.$GetDepartment, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.departmentOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetPosition() {
                try {
                    const response = await this.$API.get(this.$GetPosition, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.positionOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetBank() {
                try {
                    const response = await this.$API.get(this.$GetBank, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.bankOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetEmployment() {
                try {
                    const response = await this.$API.get(this.$GetEmployment, {
                        withCredentials: true,
                    });
                    if (response.status === 200) {
                        this.employmentOptions = response.data;
                    } else {
                        // Handle non-200 status code
                        console.error("Failed to fetch user information:", response);
                    }
                } catch (error) {
                    console.error("Error fetching user information:", error);
                    // Handle the error here
                }
        },
        async GetUserType() {
              try {
                  const response = await this.$API.get(this.$GetUserType);
                  if (response.status === 200) {
                      this.roleOptions = response.data;
                  } else {
                      // Handle non-200 status code
                      console.error("Failed to fetch user information:", response);
                  }
              } catch (error) {
                  console.error("Error fetching user information:", error);
                  // Handle the error here
              }
        },

        async GetListAllStaff() {
          try {
            const response = await this.$API.get(this.$GetListAllStaff, {
              withCredentials: true,
            });
            if (response.status === 200) {
              this.allStaff = response.data.map((staff) => ({
                FullName: staff.FullName,
                StaffNo: staff.StaffNo,
                DateJoinCompany: staff.DateJoinCompany,
                Email: staff.Email,
                PhoneNumber: staff.PhoneNumber,
                UserType: staff.UserType,
                Id: staff.Id,
                DepartmentName: staff.DepartmentName,
                PositionName: staff.PositionName,
                Active: staff.Active,
                Nric: staff.Nric,
                Address: staff.Address,
                BankName: staff.BankName,
                AccBankNo: staff.AccBankNo,
                StatusEmployment: staff.StatusEmployment,
              }));
              console.log("listStaff", this.allStaff);
            } else {
              console.error("Failed to fetch user information:", response);
            }
          } catch (error) {
            console.error("Error fetching user information:", error);
          }
        },

        async GetListDetailStaff(id) {
            try {
                console.log("id" + id);
                const response = await this.$API.get(this.$GetStaffDetails + "?id=" + id, {
                    withCredentials: true,
                });
                if (response.status === 200) {

                    this.detailStaff = response.data;

                } else {
                    console.error("Failed to fetch information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
            }
        },

        async DeactiveStaff(id) {
          const formData = new FormData();

          formData.append("Id", id);

          return this.$API
            .post(this.$DeactiveStaff, formData, {
              withCredentials: true,
            })
            .then((response) => {
              this.info = response.data;

              if (response.status == 200) {
                this.$dialog.alert("Details User Deactive!");
                this.RefreshData();
              } else console.log("Error Deleting");
            })
            .catch((error) => {
              console.log(error);
            });
        },

        RegisterStaff() {
            this.lblProgress = "Processing";

            const formData = new FormData();

            console.log("test register")

                this.buttonLabel = 'Processing';
                formData.append("name", this.name);
                formData.append("nric", this.nric);
                formData.append("address", this.address);
                formData.append("email", this.userEmail);
                formData.append("countryId", this.selectedCountry.Id);
                formData.append("phone", this.phone);
                formData.append("staffNo", this.staffNo);
                formData.append("statusEmploymentId", this.selectedEmployment.Id);
                formData.append("dateJoinCompany", this.dateJoinCompany);
                formData.append("departmentId", this.selectedDepartment.Id);
                formData.append("positionId", this.selectedPosition.Id);
                formData.append("bankId", this.selectedBank.Id);
                formData.append("accBankNo", this.accBankNo);
                formData.append("userType", this.selectedRole.Id);

                this.$API
                    .post(this.$NewRegisterStaff, formData, {
                    withCredentials: true,
                  })
                    .then((response) => {
                        if (response.data.status === 400) {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;

                        }
                        if (response.status == 200) {
                          this.$dialog
                  .alert(
                    "You have successfully added staff and the email was sent to" +
                    "\n" +
                    this.userEmail)
                  .then(function () {});

                          this.$router.push("RegisterStaff");

                            if (response.data.status !== 400) {
                                if (response.data.status !== 400) {

                                    if (
                                        this.$route.query.targetUrl != "" &&
                                        (this.$route.query.targetUrl != null) &
                                        (this.$route.query.targetUrl != undefined)
                                    ) {
                                        this.$router.push(this.$route.query.targetUrl);
                                    } else {
                                        //this.isLanguagePopupVisible1 = true;
                                        
                                    }
                                } else {
                                    this.Loading = false;
                                    this.Message = response.data.message;
                                    this.Error = true;
                                    this.MessageError = true;
                                }

                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                                this.MessageError = true;
                            }
                        }
                        
                        else {
                            this.Loading = false;
                            this.Error = true;
                            this.Message = response.data.message;
                            this.MessageError = true;
                        }
                    })
                    .catch((error) => {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = error.response.data.message;
                        this.MessageError = true;
                    });
        },

        async openDetails(id) {
            this.Id = id;
            await this.GetListDetailStaff(id);
            this.OpenDetail = true;

            this.$router.push({ path: '/SettingProfile', query: { id } });
        },
        closePopupDetail()
        {
            this.OpenDetail = false;
        },

        async editStatus(id) {
            this.Id = id;
            await this.GetListDetailStaff(id);
            this.OpenEdit = true;
        },
        closePopupEdit() {
            this.OpenEdit = false;

        },
        // closePopupSuccess()
        // {
        //     this.isPopupSuccess = false;
        //     this.OpenEdit = false
        // },

        SubmitUpdate(Id) {
            const formData = new FormData();

            formData.append("id", Id);
            formData.append("name", this.FullName);
            formData.append("nric", this.Nric);
            formData.append("address", this.address);
            formData.append("email", this.userEmail);
            formData.append("phone", this.PhoneNumber);
            formData.append("staffNo", this.staffNo);
            formData.append("statusEmploymentId", this.StatusEmployment.Id);
            formData.append("dateJoinCompany", this.dateJoinCompany);
            formData.append("departmentId", this.DepartmentName.Id);
            formData.append("positionId", this.PositionName.Id);
            formData.append("bankId", this.BankName.Id);
            formData.append("accBankNo", this.accBankNo);
            formData.append("userType", this.UserType.Id);


            this.$API
                .post(this.$UpdateStatusEvent, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;

                    }
                    if (response.status == 200) {
                        this.loadData();
                        this.isPopupSuccess = true;

                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },

        loadData() {
            console.log('Calling API with SearchQuery:', this.SearchQuery);
            this.Busy = true;
            let url = `read/GetListAllStaff?page=${this.currentPage}&limit=${this.pageSize}&keyword=${this.SearchQuery}`;

            console.log('Complete URL:', url);

            return this.$API
                .get(url, { withCredentials: true })
                .then((response) => {
                    this.Busy = false;
                    if (response.status === 200) {
                        if (response.data === 500) {
                            // Handle 'No Event' response
                            this.listStaffTableData = [];
                            this.filteredListStaffTableData = [];
                            this.hasNextPage = false; // Disable next button
                            this.totalPages = this.currentPage; // Stop pagination
                        } else {
                            this.listStaffTableData = response.data;
                            this.filteredListStaffTableData = this.listStaffTableData;

                            // Assume response.data provides info to calculate totalPages
                            // Example: if total pages info is available in response headers or response
                            // this.totalPages = response.headers['x-total-pages'] || 1; // Adjust based on API response
                            this.hasNextPage = this.currentPage < this.totalPages; // Enable or disable next button
                        }
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    console.error('Error fetching data:', error);
                    this.hasNextPage = false; // Disable next button in case of error
                });
        },
        applyFilter() {
            this.Busy = true;

            return this.loadData();
        },
        loadPage(pageNumber) {
            this.currentPage = pageNumber;
            this.loadData();
        },
        loadFirstPage() {
            this.currentPage = 1;
            this.loadData();
        },
        loadPrevPage() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.loadData();
            }
        },
        loadNextPage() {
            if (this.hasNextPage) { // Check if next page should be loaded
                this.currentPage += 1;
                this.loadData();
            }
        },
        loadLastPage() {
            this.currentPage = this.totalPages;
            this.loadData();
        },
        statusClass(status) {
            if (status === true) {
            return 'status-joined';
            } else if (status === null) {
            return 'status-pending';
            } else {
            return 'status-deactive';
            }
        },
    }
};
</script>

<style scoped>
@import url('https://fonts.cdnfonts.com/css/general-sans');
body {
    top: 0 !important;
    font-family: 'General Sans', sans-serif;
}

.phone-input {
  display: flex;
  align-items: center;
}
.country-code-select {
  width: 100px;
  margin-right: 10px;
}
.phone-number-input {
  flex: 1;
}
.status-joined {
  background-color: #ECFDF3;
  color: #13B957; 
  padding: 2px 5px; 
  border-radius: 3px; 
  font-style: italic;
}
.status-pending {
  background-color: #f9f9db;
  color: #ffea00; 
  padding: 2px 5px; 
  border-radius: 3px;
  font-style: italic;
}
.status-deactive {
  background-color: #FCEDEE;
  color: #E03137; 
  padding: 2px 5px; 
  border-radius: 3px;
  font-style: italic;
}
.custom-table {
    border-bottom: 1px solid var(--Gray-200, #EAECF0);
    background: var(--Gray-50, #F9FAFB);
    font-family: Inter;
    color: var(--Grey-HR, #98A2B3);
    /* Text xs/Medium */
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    /* 150% */
}
</style>